import React, { useEffect, useState } from "react";
import {
  Box,
  HStack,
  Icon,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Text
} from "@chakra-ui/react";
import { BsCaretDownFill } from "react-icons/bs";

interface Props {
  options: {
    label: string;
    callback: () => any;
  }[];
  //index: number;
  setIndex?: any;
}

const DropdownMenu: React.FC<Props> = ({ options, setIndex }: Props, /* index: number, */ /* setIndex?: any */) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const handleClick = (callback: () => any, index: number) => {
    callback();
    setSelectedIndex(index);
    //setIndex(index);
  };

  useEffect(() => {
   if (setIndex != null) {
      setIndex(selectedIndex);
    }
  },[selectedIndex]);

  return (
    <Popover trigger="click">
      <PopoverTrigger>
        <HStack
          rounded="xl"
          spacing={3}
          p={2}
          _hover={{
            bgColor: "gray.700",
            cursor: "pointer"
          }}
        >
          <Text fontSize="md" fontWeight="600" color="blue.500">
            {options[selectedIndex].label}
          </Text>
          <Icon w={4} h={4} as={BsCaretDownFill} />
        </HStack>
      </PopoverTrigger>
      <PopoverContent
        fontSize="md"
        fontWeight="500"
        border="0"
        bg="gray.700"
        color="white"
        width="fit-content"
        margin="0 auto"
        right="0"
        boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
      >
        <PopoverBody p={0} overflow="hidden">
          {options.map(({ label, callback }, index) => (
            <Box
              _hover={{
                cursor: "pointer",
                bg: "gray.600"
              }}
              px={6}
              py={2}
              key={index}
              onClick={() => handleClick(callback, index)}
            >
              {label}
            </Box>
          ))}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default DropdownMenu;
